import { Module, VuexModule, Action } from "vuex-module-decorators";
import api from "@/api/invest_log";

@Module({ namespaced: true })
export default class extends VuexModule {
  @Action
  async info(params: any) {
    return api.info(params);
  }
  @Action
  async list(params: any) {
    return api.list(params);
  }
  @Action
  async audits(params: any) {
    return api.audits(params);
  }
  @Action
  async correct(params: any) {
    return api.correct(params);
  }
}
